import './choosecategory.scss'

import {wrap} from '@codeurs/front'
import {ChooseCategoryData} from 'campagne/types'
import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'
import {Layout} from 'views/campagne/layout'
import {BannerCta} from 'views/campagne/partials/banner'
import {InspirationBlock} from 'views/campagne/partials/inspirationblock'
import {Theme} from 'views/campagne/theme'
import {ButtonOptional, ButtonPrimary} from 'views/ui/Button'

const styles = style('choosecategory')

export const Choosecategory: FunctionComponent<ChooseCategoryData> = wrap(
	Layout
)(({inspirations, banner, register_action_url}) => {
	const t = useTranslation('campagne').inspirations
	return (
		<div class={styles}>
			<div class={styles('overview')}>
				<Theme.Container>
					<div class={styles('overview-inspirations')}>
						{inspirations &&
							inspirations.length > 0 &&
							inspirations.map(inspiration => (
								<div class={styles('overview-inspirations-block')}>
									<InspirationBlock
										{...inspiration}
										buttonArray={[
											<ButtonOptional to={inspiration.url}>
												{t.checkout}
											</ButtonOptional>,
											<ButtonPrimary
												to={`${register_action_url}?inspiratie=${inspiration.id}`}
											>
												{t.select}
											</ButtonPrimary>
										]}
									/>
								</div>
							))}
					</div>
					<div class={styles('banner')}>
						<BannerCta
							headingLeft={banner.title1}
							headingRight={banner.title2}
							description={banner.text}
							ctaLink={banner.link}
							{...banner}
						/>
					</div>
				</Theme.Container>
			</div>
		</div>
	)
})
